import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const HeaderBackground = styled(Box)(({ theme }) => {
  const isLightMode = theme.palette.mode === "light";
  const maskOpacity = isLightMode ? 0.65 : 0.45;
  const maskPosition = isLightMode ? "65%" : "10%";

  return {
    position: "fixed",
    width: "100%",
    height: "60%",
    background: `url('https://challenge-thumbs.b-cdn.net/byb-backgrounds/progress_header.png?width=1440&height=720')`,
    backgroundSize: "cover",
    backgroundPosition: `center top ${theme.spacing(-4)}`,
    zIndex: 0,
    mask: `linear-gradient(to bottom, 
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, ${maskOpacity}) ${maskPosition},
      rgba(0, 0, 0, 0) 100%
    )`,
  };
});
